<template>
  <v-app>
    <v-progress-linear
      :active="loading"
      :indeterminate="loading"
      absolute
      top
      class="route-loader"
      color="primary"
    ></v-progress-linear>
    <component :is="resolveLayoutVariant" :class="`skin-variant--${appSkinVariant}`">
      <transition :name="appRouteTransition" mode="out-in" appear>
        <router-view></router-view>
      </transition>
    </component>
    <!-- toaster component -->
    <success-toster></success-toster>
    <notification-toaster></notification-toaster>
    <DocumentModal v-if="openDocumentModal" :is-document-modal="openDocumentModal" />
    <DetailModuleModal v-if="openDetailModal" :is-document-modal="openDetailModal" />
    <!-- <Chatbot /> -->
    <AIChat />
    <!-- image viewer component -->
    <GlobalViewer v-if="getIsOpenViewer" />
    <v-navigation-drawer
      v-model="openTaskBar"
      temporary
      :hide-overlay="true"
      app
      :stateless="true"
      right
      :width="isFullWidth ? '100%' : 720"
      style="z-index: 9"
    >
      <ViewTaskBar
        v-if="openTaskBar"
        @resetFullWidth="isFullWidth = false"
        @fullWidth="setFullWidth"
      />
    </v-navigation-drawer>
    <subscription-over-modal></subscription-over-modal>
  </v-app>
</template>

<script>
// eslint-disable-next-line object-curly-newline
import LayoutBlank from '@/layouts/variants/blank/LayoutBlank.vue'
import LayoutContentHorizontalNav from '@/layouts/variants/content/horizontal-nav/LayoutContentHorizontalNav.vue'
import LayoutContentTabNav from '@/layouts/variants/content/horizontal-nav/LayoutContentTabNav.vue'
import LayoutContentVerticalNav from '@/layouts/variants/content/vertical-nav/LayoutContentVerticalNav.vue'
import PartnerPortalLayout from '@/layouts/variants/content/vertical-nav/PartnerPortalLayout.vue'
import PartnerPortalLayoutContentHorizontalNav from '@/layouts/variants/content/horizontal-nav/PartnerPortalLayoutContentHorizontalNav.vue'
import LayoutMoveable from '@/layouts/variants/content/moveable-nav/LayoutMoveable.vue'
import DocumentModal from '@/components/documentation/index.vue'
import DetailModuleModal from '@/components/documentation/DetailModuleModal.vue'
// eslint-disable-next-line import/no-unresolved
import useAppConfig from '@core/@app-config/useAppConfig'
import { useLayout } from '@core/layouts/composable/useLayout'
import { useRouter } from '@core/utils'
// Layouts
import useDynamicVh from '@core/utils/useDynamicVh'
import { mdiPencil } from '@mdi/js'
import LayoutBlankWithNav from '@/layouts/variants/blank/LayoutBlankWithNav.vue'
// Dynamic vh
import { computed, ref } from '@vue/composition-api'
import store from '@/store'
import ViewTaskBar from '@/components/task-management/ViewTaskBar.vue'
import SuccessToster from './components/shared-components/toaster-components/SuccessToster.vue'
import NotificationToaster from './components/shared-components/toaster-components/NotificationToaster.vue'

import Chatbot from './components/Chatbot/chat.vue'
import AIChat from './components/Chatbot/AIChat.vue'
import GlobalViewer from './components/shared-components/GlobalViewer.vue'
import SubscriptionOverModal from './components/subscription/SubscriptionOverModal.vue'

export default {
  components: {
    LayoutContentVerticalNav,
    LayoutContentHorizontalNav,
    PartnerPortalLayoutContentHorizontalNav,
    LayoutBlank,
    LayoutContentTabNav,
    SuccessToster,
    LayoutMoveable,
    NotificationToaster,
    LayoutBlankWithNav,
    DocumentModal,
    DetailModuleModal,
    PartnerPortalLayout,
    Chatbot,
    AIChat,
    GlobalViewer,
    ViewTaskBar,
    SubscriptionOverModal,
  },
  setup() {
    const loading = computed(() => store.getters['app/getRouteLoader'])
    const openDocumentModal = computed(() => store.getters['documentation/getOpenDocumentModal'])
    const openDetailModal = computed(() => store.getters['documentation/getOpenDetailModal'])
    const { route } = useRouter()
    const { appContentLayoutNav, appSkinVariant, appRouteTransition } = useAppConfig()
    const getIsOpenViewer = computed(() => store.getters['imageViewer/getIsOpenViewer'])
    const isFullWidth = ref(false)

    const { handleBreakpointLayoutSwitch } = useLayout()
    handleBreakpointLayoutSwitch()

    const setFullWidth = () => {
      console.log('[101] => true')
      isFullWidth.value = true

      console.log('[105] =>', isFullWidth.value)
    }

    const resolveLayoutVariant = computed(() => {
      if (route.value.meta.layout === 'blank') return 'layout-blank'
      if (route.value.meta.layout === 'blankNav') return 'layout-blank-with-nav'
      if (route.value.meta.layout === 'moveable') return 'layout-moveable'
      if (route.value.meta.layout === 'content') {
        return `layout-content-${appContentLayoutNav.value}-nav`
      }
      if (route.value.meta.layout === 'tab') return 'layout-content-tab-nav'
      if (route.value.meta.layout === 'horizontal') return 'layout-content-horizontal-nav'
      if (route.value.meta.layout === 'partner-horizontal') return 'partner-portal-layout-content-horizontal-nav'
      if (route.value.meta.layout === 'partner') return 'partner-portal-layout'

      return null
    })

    useDynamicVh()

    const openTaskBar = computed({
      get() {
        return store.getters['taskManagement/getOpenTaskBar']
      },
      set(value) {
        store.commit('taskManagement/SET_OPEN_BAR', value)
      },
    })

    return {
      resolveLayoutVariant,
      appSkinVariant,
      appRouteTransition,
      mdiPencil,
      openDetailModal,
      loading,
      openDocumentModal,
      getIsOpenViewer,
      openTaskBar,
      isFullWidth,
      setFullWidth,
    }
  },
  created() {
    // document.addEventListener('contextmenu', event => event.preventDefault());
  },
}
</script>
<style scoped lang="scss">
::v-deep {
  .route-loader {
    z-index: 10;
    .v-progress-linear__indeterminate--active {
      > .v-progress-linear__indeterminate {
        background: #fe724c;
      }
    }
  }
}
</style>
